module.exports = __webpack_public_path__ + "img/03-B07.8921711f.png";